import { render, staticRenderFns } from "./searchDetail.vue?vue&type=template&id=2a0c854d"
import script from "./searchDetail.vue?vue&type=script&lang=js"
export * from "./searchDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports